module.exports = __webpack_public_path__ + "img/qiuzhizhaopin.cd8ecdab.png";